import { supabase } from "@/integrations/supabase/client";

/**
 * Starts Google sign-in directly through BailBuddies' Supabase Auth project.
 *
 * Production must not route through Lovable's OAuth broker. Google OAuth is
 * configured against the standalone BailBuddies Supabase project and returns
 * to the BailBuddies callback route.
 */
export async function signInWithGoogle(
  callbackUrl: string,
): Promise<{ error?: unknown; redirected?: boolean }> {
  const { error: signOutError } = await supabase.auth.signOut({ scope: "local" });
  if (signOutError) return { error: signOutError };

  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo: callbackUrl,
      queryParams: {
        prompt: "select_account",
      },
    },
  });

  if (error) return { error };
  return { redirected: Boolean(data?.url) };
}
